import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  switch: {
    minWidth: "68px",
    height: "31px",
    boxShadow: "0px 100px 309px rgba(210, 208, 225, 0.24), 0px 41.7776px 129.093px rgba(210, 208, 225, 0.172525), 0px 22.3363px 69.0192px rgba(210, 208, 225, 0.143066), 0px 12.5216px 38.6916px rgba(210, 208, 225, 0.12), 0px 6.6501px 20.5488px rgba(210, 208, 225, 0.0969343), 0px 2.76726px 8.55082px rgba(210, 208, 225, 0.0674749)",
    borderRadius: "12px",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    padding: "0 19px",
    zIndex: "10",
    userSelect: "none"
  },
  enabledSwitch: {
    color: "#003A22",
    background: theme.palette.primary.primary300,
  },
  disabledSwitch: {
    color: "#656575 !important",
    background: "#FFFFFF",
  },
}));

export default useStyles;
